export const IMG_CDN_URL = 'https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/';
export const FETCH_MENU_URL ='https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.8892684&lng=77.63991&submitAction=ENTER&restaurantId=';


export const restuarantList = [
    {
    "type": "restaurant",
    "data": {
    "type": "F",
    "id": "668624",
    "name": "Popeyes",
    "uuid": "5f6626b6-ff3b-4bd1-afc1-1dc71deb04be",
    "city": "1",
    "area": "2nd Stage",
    "totalRatingsString": "100+ ratings",
    "cloudinaryImageId": "61f2bd5d86640a55419ffe358af97b03",
    "cuisines": [
    "Snacks",
    "Burgers"
    ],
    "tags": [],
    "costForTwo": 50000,
    "costForTwoString": "₹500 FOR TWO",
    "deliveryTime": 37,
    "minDeliveryTime": 37,
    "maxDeliveryTime": 37,
    "slaString": "37 MINS",
    "lastMileTravel": 5,
    "slugs": {
    "restaurant": "popeyes-btm-layout-btm",
    "city": "bangalore"
    },
    "cityState": "1",
    "address": "Ground Floor, #804, 7th Cross, 2nd Stage,BTM Layout, 560076",
    "locality": "BTM Layout",
    "parentId": 397044,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [],
    "ribbon": [
    {
    "type": "PROMOTED"
    }
    ],
    "chain": [],
    "feeDetails": {
    "fees": [
    {
    "name": "distance",
    "fee": 4700,
    "message": ""
    },
    {
    "name": "time",
    "fee": 0,
    "message": ""
    },
    {
    "name": "special",
    "fee": 0,
    "message": ""
    }
    ],
    "totalFees": 4700,
    "message": "",
    "title": "Delivery Charge",
    "amount": "4700",
    "icon": ""
    },
    "availability": {
    "opened": true,
    "nextOpenMessage": "",
    "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "cid=6465393~p=1~eid=00000187-80ae-e1d9-0f89-f54100b10147",
    "badges": {
    "imageBased": [],
    "textBased": [],
    "textExtendedBadges": []
    },
    "lastMileTravelString": "5 kms",
    "hasSurge": false,
    "sla": {
    "restaurantId": "668624",
    "deliveryTime": 37,
    "minDeliveryTime": 37,
    "maxDeliveryTime": 37,
    "lastMileTravel": 5,
    "lastMileDistance": 0,
    "serviceability": "SERVICEABLE",
    "rainMode": "NONE",
    "longDistance": "NOT_LONG_DISTANCE",
    "preferentialService": false,
    "iconType": "EMPTY"
    },
    "promoted": true,
    "avgRating": "4.2",
    "totalRatings": 100,
    "new": false
    },
    "subtype": "basic"
    },
    {
    "type": "restaurant",
    "data": {
    "type": "F",
    "id": "167101",
    "name": "Meghana Foods",
    "uuid": "9bdcbf89-5b7d-497f-abc4-0e6ddc0048fd",
    "city": "1",
    "area": "Arakere",
    "totalRatingsString": "10000+ ratings",
    "cloudinaryImageId": "cvo1djhbwrgfqd64k0tl",
    "cuisines": [
    "Biryani",
    "Andhra",
    "South Indian",
    "North Indian",
    "Chinese",
    "Seafood"
    ],
    "tags": [],
    "costForTwo": 50000,
    "costForTwoString": "₹500 FOR TWO",
    "deliveryTime": 44,
    "minDeliveryTime": 44,
    "maxDeliveryTime": 44,
    "slaString": "44 MINS",
    "lastMileTravel": 6.099999904632568,
    "slugs": {
    "restaurant": "meghana-foods-arekere-arekere",
    "city": "bangalore"
    },
    "cityState": "1",
    "address": "No. 23/1,Bannerghatta Road, Arekere Village, Begur Hobli, Bangalore",
    "locality": "Bannergatta Main Road",
    "parentId": 635,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [],
    "chain": [],
    "feeDetails": {
    "fees": [
    {
    "name": "distance",
    "fee": 5500,
    "message": ""
    },
    {
    "name": "time",
    "fee": 0,
    "message": ""
    },
    {
    "name": "special",
    "fee": 0,
    "message": ""
    }
    ],
    "totalFees": 5500,
    "message": "",
    "title": "Delivery Charge",
    "amount": "5500",
    "icon": ""
    },
    "availability": {
    "opened": true,
    "nextOpenMessage": "",
    "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
    "imageBased": [],
    "textBased": [],
    "textExtendedBadges": []
    },
    "lastMileTravelString": "6 kms",
    "hasSurge": false,
    "sla": {
    "restaurantId": "167101",
    "deliveryTime": 44,
    "minDeliveryTime": 44,
    "maxDeliveryTime": 44,
    "lastMileTravel": 6.099999904632568,
    "lastMileDistance": 0,
    "serviceability": "SERVICEABLE",
    "rainMode": "NONE",
    "longDistance": "NOT_LONG_DISTANCE",
    "preferentialService": false,
    "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "4.4",
    "totalRatings": 10000,
    "new": false
    },
    "subtype": "basic"
    },
    {
    "type": "restaurant",
    "data": {
    "type": "F",
    "id": "17310",
    "name": "KFC",
    "uuid": "a5e9806f-1ed8-4e9f-8499-f2fd6a16327a",
    "city": "1",
    "area": "HSR Layout",
    "totalRatingsString": "10000+ ratings",
    "cloudinaryImageId": "56c9ab92bd79745fd152a30fa2525426",
    "cuisines": [
    "Burgers",
    "Biryani",
    "American",
    "Snacks",
    "Fast Food"
    ],
    "tags": [],
    "costForTwo": 40000,
    "costForTwoString": "₹400 FOR TWO",
    "deliveryTime": 48,
    "minDeliveryTime": 48,
    "maxDeliveryTime": 48,
    "slaString": "48 MINS",
    "lastMileTravel": 3,
    "slugs": {
    "restaurant": "kfc-hsr-hsr",
    "city": "bangalore"
    },
    "cityState": "1",
    "address": "KFC- HSR Layout, Shop# 30, 14th Main, Opp BDA Shopping Complex, Bangalore - 560034",
    "locality": "4th Sector",
    "parentId": 547,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [],
    "aggregatedDiscountInfo": {
    "header": "40% off",
    "shortDescriptionList": [
    {
    "meta": "40% off | Use SWIGGYIT",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    }
    ],
    "descriptionList": [
    {
    "meta": "40% off up to ₹80 on select items | Use code SWIGGYIT",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    }
    ],
    "subHeader": "",
    "headerType": 0,
    "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
    "header": "40% OFF",
    "shortDescriptionList": [
    {
    "meta": "Use SWIGGYIT",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    }
    ],
    "descriptionList": [
    {
    "meta": "40% off up to ₹80 on select items | Use code SWIGGYIT",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    }
    ],
    "subHeader": "",
    "headerType": 0,
    "superFreedel": ""
    },
    "ribbon": [
    {
    "type": "PROMOTED"
    }
    ],
    "chain": [],
    "feeDetails": {
    "fees": [
    {
    "name": "distance",
    "fee": 3900,
    "message": ""
    },
    {
    "name": "time",
    "fee": 0,
    "message": ""
    },
    {
    "name": "special",
    "fee": 0,
    "message": ""
    }
    ],
    "totalFees": 3900,
    "message": "",
    "title": "Delivery Charge",
    "amount": "3900",
    "icon": ""
    },
    "availability": {
    "opened": true,
    "nextOpenMessage": "",
    "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "cid=6494584~p=4~eid=00000187-80ae-e1d9-0f89-f54200b1041a",
    "badges": {
    "imageBased": [],
    "textBased": [],
    "textExtendedBadges": []
    },
    "lastMileTravelString": "3 kms",
    "hasSurge": false,
    "sla": {
    "restaurantId": "17310",
    "deliveryTime": 48,
    "minDeliveryTime": 48,
    "maxDeliveryTime": 48,
    "lastMileTravel": 3,
    "lastMileDistance": 0,
    "serviceability": "SERVICEABLE",
    "rainMode": "NONE",
    "longDistance": "NOT_LONG_DISTANCE",
    "preferentialService": false,
    "iconType": "EMPTY"
    },
    "promoted": true,
    "avgRating": "4.1",
    "totalRatings": 10000,
    "new": false
    },
    "subtype": "basic"
    },
    {
    "type": "restaurant",
    "data": {
    "type": "F",
    "id": "59593",
    "name": "Al Daaz",
    "uuid": "c189b92c-d842-4595-9a1f-ff85bd67bc2a",
    "city": "1",
    "area": "Hsr Layout",
    "totalRatingsString": "10000+ ratings",
    "cloudinaryImageId": "rxsvhvcdip9dbfdijzk9",
    "cuisines": [
    "American",
    "Arabian",
    "Chinese",
    "Desserts",
    "Mughlai",
    "North Indian"
    ],
    "tags": [],
    "costForTwo": 40000,
    "costForTwoString": "₹400 FOR TWO",
    "deliveryTime": 46,
    "minDeliveryTime": 46,
    "maxDeliveryTime": 46,
    "slaString": "46 MINS",
    "lastMileTravel": 4.5,
    "slugs": {
    "restaurant": "al-daaz-hsr-hsr",
    "city": "bangalore"
    },
    "cityState": "1",
    "address": "#64 & 65, 27th Main Rd, 1st Sector HSR Layout - 560102",
    "locality": "HSR",
    "parentId": 21640,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [],
    "chain": [],
    "feeDetails": {
    "fees": [
    {
    "name": "distance",
    "fee": 3900,
    "message": ""
    },
    {
    "name": "time",
    "fee": 0,
    "message": ""
    },
    {
    "name": "special",
    "fee": 0,
    "message": ""
    }
    ],
    "totalFees": 3900,
    "message": "",
    "title": "Delivery Charge",
    "amount": "3900",
    "icon": ""
    },
    "availability": {
    "opened": true,
    "nextOpenMessage": "",
    "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
    "imageBased": [],
    "textBased": [],
    "textExtendedBadges": []
    },
    "lastMileTravelString": "4.5 kms",
    "hasSurge": false,
    "sla": {
    "restaurantId": "59593",
    "deliveryTime": 46,
    "minDeliveryTime": 46,
    "maxDeliveryTime": 46,
    "lastMileTravel": 4.5,
    "lastMileDistance": 0,
    "serviceability": "SERVICEABLE",
    "rainMode": "NONE",
    "longDistance": "NOT_LONG_DISTANCE",
    "preferentialService": false,
    "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "4.4",
    "totalRatings": 10000,
    "new": false
    },
    "subtype": "basic"
    },
    {
    "type": "restaurant",
    "data": {
    "type": "F",
    "id": "337335",
    "name": "Kannur food kitchen",
    "uuid": "c70b61bc-0f68-4e24-996b-749fbf295c35",
    "city": "1",
    "area": "BTM Layout",
    "totalRatingsString": "10000+ ratings",
    "cloudinaryImageId": "a27weqanhnszqiuzsoik",
    "cuisines": [
    "Kerala",
    "Biryani",
    "Beverages"
    ],
    "tags": [],
    "costForTwo": 20000,
    "costForTwoString": "₹200 FOR TWO",
    "deliveryTime": 40,
    "minDeliveryTime": 40,
    "maxDeliveryTime": 40,
    "slaString": "40 MINS",
    "lastMileTravel": 5.5,
    "slugs": {
    "restaurant": "kannur-food-kitchen-btm-btm",
    "city": "bangalore"
    },
    "cityState": "1",
    "address": "kannur food point, Chocolate Factory Road, Tavarekere, Cashier Layout, 1st Stage, BTM Layout, thavrakharea, Karnataka, India",
    "locality": "1st  Stage",
    "parentId": 114756,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [],
    "aggregatedDiscountInfo": {
    "header": "50% off",
    "shortDescriptionList": [
    {
    "meta": "50% off on all orders",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    },
    {
    "meta": "Free Fresh Lime Juice on orders above ₹499",
    "discountType": "Freebie",
    "operationType": "RESTAURANT"
    }
    ],
    "descriptionList": [
    {
    "meta": "50% off on all orders",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    },
    {
    "meta": "Free Fresh Lime Juice on orders above ₹499",
    "discountType": "Freebie",
    "operationType": "RESTAURANT"
    }
    ],
    "subHeader": "",
    "headerType": 0,
    "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
    "header": "50% OFF",
    "shortDescriptionList": [
    {
    "meta": "",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    }
    ],
    "descriptionList": [
    {
    "meta": "50% off on all orders",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    },
    {
    "meta": "Free Fresh Lime Juice on orders above ₹499",
    "discountType": "Freebie",
    "operationType": "RESTAURANT"
    }
    ],
    "subHeader": "",
    "headerType": 0,
    "superFreedel": ""
    },
    "chain": [],
    "feeDetails": {
    "fees": [
    {
    "name": "distance",
    "fee": 4700,
    "message": ""
    },
    {
    "name": "time",
    "fee": 0,
    "message": ""
    },
    {
    "name": "special",
    "fee": 0,
    "message": ""
    }
    ],
    "totalFees": 4700,
    "message": "",
    "title": "Delivery Charge",
    "amount": "4700",
    "icon": ""
    },
    "availability": {
    "opened": true,
    "nextOpenMessage": "",
    "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
    "imageBased": [],
    "textBased": [],
    "textExtendedBadges": []
    },
    "lastMileTravelString": "5.5 kms",
    "hasSurge": false,
    "sla": {
    "restaurantId": "337335",
    "deliveryTime": 40,
    "minDeliveryTime": 40,
    "maxDeliveryTime": 40,
    "lastMileTravel": 5.5,
    "lastMileDistance": 0,
    "serviceability": "SERVICEABLE",
    "rainMode": "NONE",
    "longDistance": "NOT_LONG_DISTANCE",
    "preferentialService": false,
    "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "3.8",
    "totalRatings": 10000,
    "new": false
    },
    "subtype": "basic"
    },
    {
    "type": "restaurant",
    "data": {
    "type": "F",
    "id": "428",
    "name": "Biryani Pot",
    "uuid": "6db20a8b-dd85-4148-b750-107169f7f826",
    "city": "1",
    "area": "Btm Layout",
    "totalRatingsString": "10000+ ratings",
    "cloudinaryImageId": "mdipoyzfzsa7n7igskht",
    "cuisines": [
    "North Indian",
    "Biryani"
    ],
    "tags": [],
    "costForTwo": 50000,
    "costForTwoString": "₹500 FOR TWO",
    "deliveryTime": 37,
    "minDeliveryTime": 37,
    "maxDeliveryTime": 37,
    "slaString": "37 MINS",
    "lastMileTravel": 5,
    "slugs": {
    "restaurant": "biryani-pot-madiwala-junction-btm",
    "city": "bangalore"
    },
    "cityState": "1",
    "address": "14th  Cross, 4th link Road Maruthi Nagar Madiwala Bangalore 68",
    "locality": "Maruti Nagar",
    "parentId": 21798,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [],
    "aggregatedDiscountInfo": {
    "header": "20% off",
    "shortDescriptionList": [
    {
    "meta": "20% off | Use TRYNEW",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    }
    ],
    "descriptionList": [
    {
    "meta": "20% off up to ₹50 | Use code TRYNEW",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    }
    ],
    "subHeader": "",
    "headerType": 0,
    "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
    "header": "20% OFF",
    "shortDescriptionList": [
    {
    "meta": "Use TRYNEW",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    }
    ],
    "descriptionList": [
    {
    "meta": "20% off up to ₹50 | Use code TRYNEW",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    }
    ],
    "subHeader": "",
    "headerType": 0,
    "superFreedel": ""
    },
    "chain": [],
    "feeDetails": {
    "fees": [
    {
    "name": "distance",
    "fee": 4700,
    "message": ""
    },
    {
    "name": "time",
    "fee": 0,
    "message": ""
    },
    {
    "name": "special",
    "fee": 0,
    "message": ""
    }
    ],
    "totalFees": 4700,
    "message": "",
    "title": "Delivery Charge",
    "amount": "4700",
    "icon": ""
    },
    "availability": {
    "opened": true,
    "nextOpenMessage": "",
    "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
    "imageBased": [],
    "textBased": [],
    "textExtendedBadges": []
    },
    "lastMileTravelString": "5 kms",
    "hasSurge": false,
    "sla": {
    "restaurantId": "428",
    "deliveryTime": 37,
    "minDeliveryTime": 37,
    "maxDeliveryTime": 37,
    "lastMileTravel": 5,
    "lastMileDistance": 0,
    "serviceability": "SERVICEABLE",
    "rainMode": "NONE",
    "longDistance": "NOT_LONG_DISTANCE",
    "preferentialService": false,
    "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "3.9",
    "totalRatings": 10000,
    "new": false
    },
    "subtype": "basic"
    }]